webpackJsonp([114276838955818,60335399758886],{

/***/ 228:
/***/ (function(module, exports) {

	module.exports = {"layoutContext":{}}

/***/ }),

/***/ 438:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(60);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__(446);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _layoutIndex = __webpack_require__(228);
	
	var _layoutIndex2 = _interopRequireDefault(_layoutIndex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(_index2.default, (0, _extends3.default)({}, props, _layoutIndex2.default));
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 624:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	// adapted from https://github.com/WICG/EventListenerOptions/blob/gh-pages/explainer.md
	var detectPassiveEvents = {
	  update: function update() {
	    if (typeof window !== 'undefined' && typeof window.addEventListener === 'function') {
	      var passive = false;
	      var options = Object.defineProperty({}, 'passive', {
	        get: function get() {
	          passive = true;
	        }
	      });
	      // note: have to set and remove a no-op listener instead of null
	      // (which was used previously), becasue Edge v15 throws an error
	      // when providing a null callback.
	      // https://github.com/rafrex/detect-passive-events/pull/3
	      var noop = function noop() {};
	      window.addEventListener('testPassiveEventSupport', noop, options);
	      window.removeEventListener('testPassiveEventSupport', noop, options);
	      detectPassiveEvents.hasSupport = passive;
	    }
	  }
	};
	
	detectPassiveEvents.update();
	exports.default = detectPassiveEvents;

/***/ }),

/***/ 1013:
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author  Milos Janda
	 * @licence MIT
	 */
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _tweenFunctions = __webpack_require__(1081);
	
	var _tweenFunctions2 = _interopRequireDefault(_tweenFunctions);
	
	var _detectPassiveEvents = __webpack_require__(624);
	
	var _detectPassiveEvents2 = _interopRequireDefault(_detectPassiveEvents);
	
	var _objectAssign = __webpack_require__(15);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ScrollUp = function (_React$Component) {
	    _inherits(ScrollUp, _React$Component);
	
	    function ScrollUp(props) {
	        _classCallCheck(this, ScrollUp);
	
	        // set default state
	        var _this = _possibleConstructorReturn(this, (ScrollUp.__proto__ || Object.getPrototypeOf(ScrollUp)).call(this, props));
	
	        _this.state = { show: false };
	
	        // default property `data`
	        _this.data = {
	            startValue: 0,
	            currentTime: 0, // store current time of animation
	            startTime: null,
	            rafId: null
	        };
	
	        // bind
	        _this.handleClick = _this.handleClick.bind(_this);
	        _this.handleScroll = _this.handleScroll.bind(_this);
	        _this.scrollStep = _this.scrollStep.bind(_this);
	        _this.stopScrolling = _this.stopScrolling.bind(_this);
	        return _this;
	    }
	
	    _createClass(ScrollUp, [{
	        key: 'shouldComponentUpdate',
	        value: function shouldComponentUpdate(nextProps, nextState) {
	            return nextState.show !== this.state.show;
	        }
	    }, {
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.handleScroll(); // initialize state
	
	            // Add all listeners which can start scroll
	            window.addEventListener('scroll', this.handleScroll);
	            window.addEventListener("wheel", this.stopScrolling, _detectPassiveEvents2.default.hasSupport ? { passive: true } : false);
	            window.addEventListener("touchstart", this.stopScrolling, _detectPassiveEvents2.default.hasSupport ? { passive: true } : false);
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            // Remove all listeners which was registered
	            window.removeEventListener('scroll', this.handleScroll);
	            window.removeEventListener("wheel", this.stopScrolling, false);
	            window.removeEventListener("touchstart", this.stopScrolling, false);
	        }
	
	        /**
	         * Evaluate show/hide this component, depend on new position
	         */
	
	    }, {
	        key: 'handleScroll',
	        value: function handleScroll() {
	            if (window.pageYOffset > this.props.showUnder) {
	                if (!this.state.show) {
	                    this.setState({ show: true });
	                }
	            } else {
	                if (this.state.show) {
	                    this.setState({ show: false });
	                }
	            }
	        }
	
	        /**
	         * Handle click on the button
	         */
	
	    }, {
	        key: 'handleClick',
	        value: function handleClick() {
	            this.stopScrolling();
	            this.data.startValue = window.pageYOffset;
	            this.data.currentTime = 0;
	            this.data.startTime = null;
	            this.data.rafId = window.requestAnimationFrame(this.scrollStep);
	        }
	
	        /**
	         * Calculate new position
	         * and scroll screen to new position or stop scrolling
	         * @param timestamp
	         */
	
	    }, {
	        key: 'scrollStep',
	        value: function scrollStep(timestamp) {
	            if (!this.data.startTime) {
	                this.data.startTime = timestamp;
	            }
	
	            this.data.currentTime = timestamp - this.data.startTime;
	
	            var position = _tweenFunctions2.default[this.props.easing](this.data.currentTime, this.data.startValue, this.props.topPosition, this.props.duration);
	
	            if (window.pageYOffset <= this.props.topPosition) {
	                this.stopScrolling();
	            } else {
	                window.scrollTo(window.pageYOffset, position);
	                this.data.rafId = window.requestAnimationFrame(this.scrollStep);
	            }
	        }
	
	        /**
	         * Stop Animation Frame
	         */
	
	    }, {
	        key: 'stopScrolling',
	        value: function stopScrolling() {
	            window.cancelAnimationFrame(this.data.rafId);
	        }
	
	        /**
	         * Render component
	         */
	
	    }, {
	        key: 'render',
	        value: function render() {
	
	            var propStyle = this.props.style;
	            var element = _react2.default.createElement(
	                'div',
	                { style: propStyle, onClick: this.handleClick },
	                this.props.children
	            );
	
	            var style = (0, _objectAssign2.default)({}, ScrollUp.defaultProps.style);
	            style = (0, _objectAssign2.default)(style, propStyle);
	            style.opacity = this.state.show ? 1 : 0;
	            style.visibility = this.state.show ? 'visible' : 'hidden';
	            style.transitionProperty = 'opacity, visibility';
	
	            return _react2.default.cloneElement(element, { style: style });
	        }
	    }]);
	
	    return ScrollUp;
	}(_react2.default.Component);
	
	// Set default props
	
	
	exports.default = ScrollUp;
	ScrollUp.defaultProps = {
	    duration: 250,
	    easing: 'easeOutCubic',
	    style: {
	        position: 'fixed',
	        bottom: 50,
	        right: 30,
	        cursor: 'pointer',
	        transitionDuration: '0.2s',
	        transitionTimingFunction: 'linear',
	        transitionDelay: '0s'
	    },
	    topPosition: 0
	};
	
	// Set validation property types
	ScrollUp.propTypes = {
	    topPosition: _propTypes2.default.number,
	    showUnder: _propTypes2.default.number.isRequired, // show button under this position,
	    easing: _propTypes2.default.oneOf(['linear', 'easeInQuad', 'easeOutQuad', 'easeInOutQuad', 'easeInCubic', 'easeOutCubic', 'easeInOutCubic', 'easeInQuart', 'easeOutQuart', 'easeInOutQuart', 'easeInQuint', 'easeOutQuint', 'easeInOutQuint', 'easeInSine', 'easeOutSine', 'easeInOutSine', 'easeInExpo', 'easeOutExpo', 'easeInOutExpo', 'easeInCirc', 'easeOutCirc', 'easeInOutCirc', 'easeInElastic', 'easeOutElastic', 'easeInOutElastic', 'easeInBack', 'easeOutBack', 'easeInOutBack', 'easeInBounce', 'easeOutBounce', 'easeInOutBounce']),
	    duration: _propTypes2.default.number, // seconds
	    style: _propTypes2.default.object
	};


/***/ }),

/***/ 1081:
/***/ (function(module, exports) {

	'use strict';
	
	// t: current time, b: beginning value, _c: final value, d: total duration
	var tweenFunctions = {
	  linear: function(t, b, _c, d) {
	    var c = _c - b;
	    return c * t / d + b;
	  },
	  easeInQuad: function(t, b, _c, d) {
	    var c = _c - b;
	    return c * (t /= d) * t + b;
	  },
	  easeOutQuad: function(t, b, _c, d) {
	    var c = _c - b;
	    return -c * (t /= d) * (t - 2) + b;
	  },
	  easeInOutQuad: function(t, b, _c, d) {
	    var c = _c - b;
	    if ((t /= d / 2) < 1) {
	      return c / 2 * t * t + b;
	    } else {
	      return -c / 2 * ((--t) * (t - 2) - 1) + b;
	    }
	  },
	  easeInCubic: function(t, b, _c, d) {
	    var c = _c - b;
	    return c * (t /= d) * t * t + b;
	  },
	  easeOutCubic: function(t, b, _c, d) {
	    var c = _c - b;
	    return c * ((t = t / d - 1) * t * t + 1) + b;
	  },
	  easeInOutCubic: function(t, b, _c, d) {
	    var c = _c - b;
	    if ((t /= d / 2) < 1) {
	      return c / 2 * t * t * t + b;
	    } else {
	      return c / 2 * ((t -= 2) * t * t + 2) + b;
	    }
	  },
	  easeInQuart: function(t, b, _c, d) {
	    var c = _c - b;
	    return c * (t /= d) * t * t * t + b;
	  },
	  easeOutQuart: function(t, b, _c, d) {
	    var c = _c - b;
	    return -c * ((t = t / d - 1) * t * t * t - 1) + b;
	  },
	  easeInOutQuart: function(t, b, _c, d) {
	    var c = _c - b;
	    if ((t /= d / 2) < 1) {
	      return c / 2 * t * t * t * t + b;
	    } else {
	      return -c / 2 * ((t -= 2) * t * t * t - 2) + b;
	    }
	  },
	  easeInQuint: function(t, b, _c, d) {
	    var c = _c - b;
	    return c * (t /= d) * t * t * t * t + b;
	  },
	  easeOutQuint: function(t, b, _c, d) {
	    var c = _c - b;
	    return c * ((t = t / d - 1) * t * t * t * t + 1) + b;
	  },
	  easeInOutQuint: function(t, b, _c, d) {
	    var c = _c - b;
	    if ((t /= d / 2) < 1) {
	      return c / 2 * t * t * t * t * t + b;
	    } else {
	      return c / 2 * ((t -= 2) * t * t * t * t + 2) + b;
	    }
	  },
	  easeInSine: function(t, b, _c, d) {
	    var c = _c - b;
	    return -c * Math.cos(t / d * (Math.PI / 2)) + c + b;
	  },
	  easeOutSine: function(t, b, _c, d) {
	    var c = _c - b;
	    return c * Math.sin(t / d * (Math.PI / 2)) + b;
	  },
	  easeInOutSine: function(t, b, _c, d) {
	    var c = _c - b;
	    return -c / 2 * (Math.cos(Math.PI * t / d) - 1) + b;
	  },
	  easeInExpo: function(t, b, _c, d) {
	    var c = _c - b;
	    return (t==0) ? b : c * Math.pow(2, 10 * (t/d - 1)) + b;
	  },
	  easeOutExpo: function(t, b, _c, d) {
	    var c = _c - b;
	    return (t==d) ? b+c : c * (-Math.pow(2, -10 * t/d) + 1) + b;
	  },
	  easeInOutExpo: function(t, b, _c, d) {
	    var c = _c - b;
	    if (t === 0) {
	      return b;
	    }
	    if (t === d) {
	      return b + c;
	    }
	    if ((t /= d / 2) < 1) {
	      return c / 2 * Math.pow(2, 10 * (t - 1)) + b;
	    } else {
	      return c / 2 * (-Math.pow(2, -10 * --t) + 2) + b;
	    }
	  },
	  easeInCirc: function(t, b, _c, d) {
	    var c = _c - b;
	    return -c * (Math.sqrt(1 - (t /= d) * t) - 1) + b;
	  },
	  easeOutCirc: function(t, b, _c, d) {
	    var c = _c - b;
	    return c * Math.sqrt(1 - (t = t / d - 1) * t) + b;
	  },
	  easeInOutCirc: function(t, b, _c, d) {
	    var c = _c - b;
	    if ((t /= d / 2) < 1) {
	      return -c / 2 * (Math.sqrt(1 - t * t) - 1) + b;
	    } else {
	      return c / 2 * (Math.sqrt(1 - (t -= 2) * t) + 1) + b;
	    }
	  },
	  easeInElastic: function(t, b, _c, d) {
	    var c = _c - b;
	    var a, p, s;
	    s = 1.70158;
	    p = 0;
	    a = c;
	    if (t === 0) {
	      return b;
	    } else if ((t /= d) === 1) {
	      return b + c;
	    }
	    if (!p) {
	      p = d * 0.3;
	    }
	    if (a < Math.abs(c)) {
	      a = c;
	      s = p / 4;
	    } else {
	      s = p / (2 * Math.PI) * Math.asin(c / a);
	    }
	    return -(a * Math.pow(2, 10 * (t -= 1)) * Math.sin((t * d - s) * (2 * Math.PI) / p)) + b;
	  },
	  easeOutElastic: function(t, b, _c, d) {
	    var c = _c - b;
	    var a, p, s;
	    s = 1.70158;
	    p = 0;
	    a = c;
	    if (t === 0) {
	      return b;
	    } else if ((t /= d) === 1) {
	      return b + c;
	    }
	    if (!p) {
	      p = d * 0.3;
	    }
	    if (a < Math.abs(c)) {
	      a = c;
	      s = p / 4;
	    } else {
	      s = p / (2 * Math.PI) * Math.asin(c / a);
	    }
	    return a * Math.pow(2, -10 * t) * Math.sin((t * d - s) * (2 * Math.PI) / p) + c + b;
	  },
	  easeInOutElastic: function(t, b, _c, d) {
	    var c = _c - b;
	    var a, p, s;
	    s = 1.70158;
	    p = 0;
	    a = c;
	    if (t === 0) {
	      return b;
	    } else if ((t /= d / 2) === 2) {
	      return b + c;
	    }
	    if (!p) {
	      p = d * (0.3 * 1.5);
	    }
	    if (a < Math.abs(c)) {
	      a = c;
	      s = p / 4;
	    } else {
	      s = p / (2 * Math.PI) * Math.asin(c / a);
	    }
	    if (t < 1) {
	      return -0.5 * (a * Math.pow(2, 10 * (t -= 1)) * Math.sin((t * d - s) * (2 * Math.PI) / p)) + b;
	    } else {
	      return a * Math.pow(2, -10 * (t -= 1)) * Math.sin((t * d - s) * (2 * Math.PI) / p) * 0.5 + c + b;
	    }
	  },
	  easeInBack: function(t, b, _c, d, s) {
	    var c = _c - b;
	    if (s === void 0) {
	      s = 1.70158;
	    }
	    return c * (t /= d) * t * ((s + 1) * t - s) + b;
	  },
	  easeOutBack: function(t, b, _c, d, s) {
	    var c = _c - b;
	    if (s === void 0) {
	      s = 1.70158;
	    }
	    return c * ((t = t / d - 1) * t * ((s + 1) * t + s) + 1) + b;
	  },
	  easeInOutBack: function(t, b, _c, d, s) {
	    var c = _c - b;
	    if (s === void 0) {
	      s = 1.70158;
	    }
	    if ((t /= d / 2) < 1) {
	      return c / 2 * (t * t * (((s *= 1.525) + 1) * t - s)) + b;
	    } else {
	      return c / 2 * ((t -= 2) * t * (((s *= 1.525) + 1) * t + s) + 2) + b;
	    }
	  },
	  easeInBounce: function(t, b, _c, d) {
	    var c = _c - b;
	    var v;
	    v = tweenFunctions.easeOutBounce(d - t, 0, c, d);
	    return c - v + b;
	  },
	  easeOutBounce: function(t, b, _c, d) {
	    var c = _c - b;
	    if ((t /= d) < 1 / 2.75) {
	      return c * (7.5625 * t * t) + b;
	    } else if (t < 2 / 2.75) {
	      return c * (7.5625 * (t -= 1.5 / 2.75) * t + 0.75) + b;
	    } else if (t < 2.5 / 2.75) {
	      return c * (7.5625 * (t -= 2.25 / 2.75) * t + 0.9375) + b;
	    } else {
	      return c * (7.5625 * (t -= 2.625 / 2.75) * t + 0.984375) + b;
	    }
	  },
	  easeInOutBounce: function(t, b, _c, d) {
	    var c = _c - b;
	    var v;
	    if (t < d / 2) {
	      v = tweenFunctions.easeInBounce(t * 2, 0, c, d);
	      return v * 0.5 + b;
	    } else {
	      v = tweenFunctions.easeOutBounce(t * 2 - d, 0, c, d);
	      return v * 0.5 + c * 0.5 + b;
	    }
	  }
	};
	
	module.exports = tweenFunctions;


/***/ }),

/***/ 441:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(8);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CookiesDialog = function CookiesDialog(props) {
	  return _react2.default.createElement(
	    "div",
	    { className: "cookie-dialog" },
	    _react2.default.createElement(
	      "div",
	      { className: "cookie-dialog-content" },
	      _react2.default.createElement(
	        "h2",
	        { className: "cookie-dialog-title" },
	        "Cookie Policy"
	      ),
	      _react2.default.createElement("p", { className: "cookie-dialog-text", "data-text": "This site uses cookies and other tracking technologies to assist with site navigation, analyse your use of our products and services. If you continue without changing your settings, we'll assume that you are happy to receive all cookies on this website. If you do not accept cookies, however, you may not be able to use all functionality of the website. Read more about cookies and how to disable them." })
	    ),
	    _react2.default.createElement(
	      "div",
	      { className: "cookie-dialog-buttons" },
	      _react2.default.createElement(
	        "div",
	        { className: "cookie-dialog-readmore" },
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: "/cookie_policy.html" },
	          "Read More"
	        )
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "cookie-dialog-accept" },
	        _react2.default.createElement(
	          "button",
	          { type: "button", onClick: props.controlFunc },
	          "Accept"
	        )
	      )
	    )
	  );
	};
	
	exports.default = CookiesDialog;
	module.exports = exports["default"];

/***/ }),

/***/ 914:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 446:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _gatsbyLink = __webpack_require__(8);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactHelmet = __webpack_require__(11);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _reactCookies = __webpack_require__(68);
	
	var _reactCookies2 = _interopRequireDefault(_reactCookies);
	
	var _CookiesDialog = __webpack_require__(441);
	
	var _CookiesDialog2 = _interopRequireDefault(_CookiesDialog);
	
	var _reactScrollUp = __webpack_require__(1013);
	
	var _reactScrollUp2 = _interopRequireDefault(_reactScrollUp);
	
	__webpack_require__(914);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Template = function (_React$Component) {
	  (0, _inherits3.default)(Template, _React$Component);
	
	  function Template() {
	    (0, _classCallCheck3.default)(this, Template);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, _React$Component.call(this));
	
	    _this.addAccept = _this.addAccept.bind(_this);
	    _this.state = {
	      showCookieDialog: false
	    };
	    return _this;
	  }
	
	  Template.prototype.handleScroll = function handleScroll(e) {
	    var scrollHeader = document.getElementById('header');
	    if (scrollHeader) {
	      if (scrollHeader.getBoundingClientRect().top !== 0) {
	        scrollHeader.className = 'header scroll';
	      } else {
	        scrollHeader.className = 'header';
	      }
	    }
	  };
	
	  Template.prototype.pageClick = function pageClick(e) {
	    document.getElementsByTagName('body')[0].className = '';
	  };
	
	  Template.prototype.addAccept = function addAccept(e) {
	
	    this.setState({ showCookieDialog: false });
	
	    var myexpires = new Date();
	    myexpires.setDate(new Date().getDate() + 10000);
	
	    _reactCookies2.default.save('CookieDialog_agreed', new Date().getTime(), { path: '/', expires: myexpires });
	  };
	
	  Template.prototype.componentDidMount = function componentDidMount() {
	
	    this.handleScroll;
	    window.addEventListener('click', this.pageClick, false);
	    window.addEventListener('scroll', this.handleScroll);
	
	    var CookieDialog_agreed = _reactCookies2.default.load('CookieDialog_agreed');
	
	    if (!CookieDialog_agreed) {
	      this.setState({ showCookieDialog: true });
	    }
	  };
	
	  Template.prototype.componentDidUpdate = function componentDidUpdate() {
	    var CookieDialog_agreed = _reactCookies2.default.load('CookieDialog_agreed');
	  };
	
	  Template.prototype.componentWillUnmount = function componentWillUnmount() {
	    window.removeEventListener('scroll', this.handleScroll);
	  };
	
	  Template.prototype.render = function render() {
	    var showCookieDialog = this.state.showCookieDialog;
	
	
	    return _react2.default.createElement(
	      "div",
	      null,
	      this.props.children(),
	      _react2.default.createElement(
	        _reactScrollUp2.default,
	        { showUnder: 160 },
	        _react2.default.createElement("span", { className: "totop" })
	      ),
	      showCookieDialog && _react2.default.createElement(_CookiesDialog2.default, { controlFunc: this.addAccept })
	    );
	  };
	
	  return Template;
	}(_react2.default.Component);
	
	Template.propTypes = {
	  children: _propTypes2.default.func
	};
	exports.default = Template;
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-layouts-index-js-7d9ab018bd17d5aff8f1.js